import { getUniqueAppId } from './string';

type DeepCloneable = { [key: string]: DeepCloneable } | DeepCloneable[] | string | number | boolean | null | undefined;

/**
 * Deeply clones an object or array.
 * @param value - The value to clone.
 * @returns A deep clone of the original value.
 */
export const deepClone = <T extends DeepCloneable>(value: T): T => {
  const type = Object.prototype.toString.call(value);

  if (type === '[object Array]') {
    return (value as DeepCloneable[]).map(deepClone) as T;
  }

  if (type === '[object Object]') {
    return Object.keys(value as object).reduce((acc, key) => {
      (acc as Record<string, DeepCloneable>)[key] = deepClone((value as Record<string, DeepCloneable>)[key]);
      return acc;
    }, {} as T);
  }

  return value;
};

export const getDummyList = (length: number): string[] =>
  new Array(Math.max(0, length)).fill(null).map(() => `dummy-item-${getUniqueAppId()}`);

export const notNullOrUndefined = <T>(key: T | null | undefined): key is T => key !== null && key !== undefined;
